import reducer from './reducers';

import * as hotelOperations from './operations';
import * as hotelSelectors from './selectors';
import * as hotelTypes from './types';

export { hotelOperations, hotelSelectors, hotelTypes };

export default reducer;
